import React from 'react';
import { RefreshIcon } from 'hugeicons-react';
import { Mode } from '../../../types/mode';
import '../../../Styles/Layout/Buttons.css';
import { HoverToolTip } from '../Items/HoverToolTip';
import { ConvexMessage } from '../../../types/message';
import { useMode } from '../../../contexts/ModeContext';

interface RegenerateButtonProps {
  message: ConvexMessage;
  onRegenerate: (messageId: string, mode: Mode) => Promise<void>;
}

export const RegenerateButton: React.FC<RegenerateButtonProps> = ({ message, onRegenerate }) => {
  const { mode } = useMode();

  return (
    <button
      type="button"
      className="action-button"
      aria-label="Regenerate message"
      onClick={() => onRegenerate(message._id, mode)}
    >
      <RefreshIcon size={16} />
      <HoverToolTip text="Regenerate" position="bottom" />
    </button>
  );
};
